import React from 'react';
import { Box, Card, CardContent, Typography } from '@material-ui/core';
import { AccountCircle as AccountCircleIcon } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';

import { formatDate } from '../../../common/formatter';
import CardTitle from '../../../common/card/CardTitle';
import { BaseSignupCardProps } from '../../../login/Signup.interface';
import { User } from '../../../user/User.interface';

function displayUser(user: User) {
  if (!user) {
    return '';
  }
  const email = user.email ? ` (${user.email})` : '';
  return `${user.firstName} ${user.lastName}${email}`;
}

const SignupUserCard: React.FC<BaseSignupCardProps> = props => {
  const { signup } = props;
  return (
    <Card>
      <CardTitle>
        <AccountCircleIcon />
        Registration Info
      </CardTitle>
      <CardContent>
        <Box mb={2}>
          <Typography>
            Registered by: <strong>{displayUser(signup.user)}</strong>
          </Typography>
          <Typography>
            Registered on: <strong>{formatDate(signup.created)}</strong>
          </Typography>
        </Box>
        <Alert severity='info'>
          Last Modified by <strong>{displayUser(signup.modifiedBy)}</strong> on{' '}
          <strong>{formatDate(signup.modified)}</strong>.
        </Alert>
      </CardContent>
    </Card>
  );
};

export default SignupUserCard;
